export enum InternalActionKeyId {
  deviceLightBrightnessDown = 0xe100,
  deviceLightBrightnessUp = 0xe101,
  deviceLightSpeedDown = 0xe102,
  deviceLightSpeedUp = 0xe103,
  deviceLightEffectMode = 0xe104,
  deviceLightColorSwitch = 0xe105,
  deviceWinMacModeSwitch = 0xe106,
  deviceLightToggle = 0xe108,
  deviceSwitchToWindowsMode = 0xe109,
  deviceSwitchToMacMode = 0xe10a,
  deviceWinKeyLock = 0xe10b,
  deviceLightDirection = 0xe10c,
  deviceFn1 = 0xe10d,
  deviceFn2 = 0xe107,
  deviceFn3 = 0xe10e,
  deviceRestore = 0xe10f,
  deviceSnapTapToggle = 0xe110,
  deviceSideLightBrightnessDown = 0xe11d,
  deviceSideLightBrightnessUp = 0xe11e,
  deviceSideLightSpeedDown = 0xe11f,
  deviceSideLightSpeedUp = 0xe120,
  deviceSideLightEffectMode = 0xe121,
  deviceSideLightColorSwitch = 0xe122,
  deviceSideLightToggle = 0xe12d,
  deviceSideLightDirection = 0xe124,
  deviceSideLightEffectPrev = 0xe125,
  deviceSideLightEffectNext = 0xe126,
  deviceSwitchToProfile1 = 0xe127,
  deviceSwitchToProfile2 = 0xe128,
  deviceSwitchToProfile3 = 0xe129,
  deviceSwitchToProfile4 = 0xe12a,
  deviceCycleProfiles = 0xe12b,
  deviceLogoLightEffectMode = 0xe12c,
  deviceOpenWebDriver = 0xe12e,
}
